import { render, staticRenderFns } from "./exam-candidates.vue?vue&type=template&id=596f09f6&scoped=true"
import script from "./exam-candidates.vue?vue&type=script&lang=ts"
export * from "./exam-candidates.vue?vue&type=script&lang=ts"
import style0 from "./exam-candidates.vue?vue&type=style&index=0&id=596f09f6&prod&lang=scss"
import style1 from "./exam-candidates.vue?vue&type=style&index=1&id=596f09f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596f09f6",
  null
  
)

export default component.exports